import ProjectTypeBadge, { ProjectType } from "components/ProjectTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegrationUser } from "types/generated";

const IntegrationsVcsUsedByTableTypeCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<VcsIntegrationUser>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ProjectTypeBadge projectType={item.isModule ? ProjectType.Module : ProjectType.Stack} />
    </TableSimpleCell>
  );
};

export default IntegrationsVcsUsedByTableTypeCell;
